export default __webpack_public_path__ + "assets/Company.f4c6.svg";